export default __webpack_public_path__ + "static/media/fuji-tokenomics.e22e68f2.png";